<template>
  <div class="user-info">
    <MainBackButton />

    <EditJSON v-if="editUserData" :obj="editUserData" @save="saveEditJSON" @close="clearEditJSON" />

    <div class="header">
      User Lookup
      <i class="fa fa-store-alt fa-sm is-pulled-right" style="padding: 6px" @click="goto('search')" />
    </div>

    <div class="field" style="margin: 0px">
      <div class="control has-icons-left">
        <input ref="input" class="input is-medium" type="text" :value="userName" @focus="clearUser"
          placeholder="Name or Mobile" @keyup="lookupUsers($event)" autocomplete="off" name="no-suggestion" />
        <span class="icon is-small is-left">
          <i class="fa fa-search fa-sm" style="margin-left: 7px" />
        </span>
      </div>
      <div class="list" v-if="users.length > 0 && !ID">
        <span v-for="u in users" class="list-item single-line no-scrollbar" :key="u.key" @click="selectUser(u)">{{ u.key
        }}</span>
      </div>
    </div>

    <div v-if="ID" class="user no-scrollbar">
      <div class="result-header tabs is-fullwidth">
        <ul>
          <li :class="{ 'is-active': tab === 'user' }" @click="tab = 'user'">
            <a>User</a>
          </li>
          <li :class="{ 'is-active': tab === 'transactions' }" @click="tab = 'transactions'">
            <a>Transactions</a>
          </li>
          <li :class="{ 'is-active': tab === 'roles' }" @click="tab = 'roles'">
            <a>Roles</a>
          </li>
        </ul>
      </div>

      <!-- <div style='padding: 10px'> -->
      <div v-if="tab === 'message'" class="tab">
        <p class="subtitle">Send Message</p>

        <div class="control">
          <textarea class="textarea" v-model="message" placeholder="Type message here" rows="5"></textarea>
        </div>
        <div style="height: 5px" />
        <div class="msg-btns">
          <span class="button" v-clipboard:copy="message" v-clipboard:success="onCopy"><i
              class="far fa-clone" />&nbsp;Copy</span>
          <span class="button has-text-link" @click="sendMessage('sms')"><i class="fa fa-sms" />&nbsp;SMS</span>
          <!-- <span class="button is-rounded round">
            <i class="fa fa-magic has-text-info" @click="specialMessages" />
          </span> -->
          <span class="button has-text-info" @click="sendMessage('push')"><i class="fa fa-paper-plane" />&nbsp;Push</span>
          <span class="button has-text-grey" @click="message = null">
            <i class="fa fa-eraser" />&nbsp;Clear</span>
        </div>
        <div class="list">
          <span v-for="m in specialMessageCommands" :key="m" class="list-item" @click="pasteSpecialMessage(m)">
            {{ m }}
            <span class="has-text-grey is-pulled-right" @click="pushSpecialMessage(m)">
              <i class="fa fa-paper-plane" />
            </span>
          </span>
          <span class="list-item" @click="pasteSpecialMessage(mobileUpdatedMsg)">
            {{ mobileUpdatedMsg }} ...
          </span>
        </div>
      </div>

      <!-- <div v-if="transactions.length > 0" class="field" > -->
      <div v-if="tab === 'transactions'" class="tab">
        <p class="subtitle">
          Transaction Stats
          <i v-if="!topShops" class="fa fa-ellipsis-h is-pulled-right" @click="showTopShops" />
        </p>
        <div v-if="topShops" class="list">
          <span v-for="s in topShops" class="list-item single-line" :key="s.id">
            {{ s.name }}
            <span class="is-pulled-right">
              <span class="stat">{{ s.count }}</span>
            </span>
          </span>
        </div>
        <div v-if="transactionStats" class="list">
          <span v-for="s in transactionStats" class="list-item single-line" :key="s.id">
            {{ s.workflow_type_name }}
            <span class="is-pulled-right">
              <span class="stat has-text-success">{{ s.success_count }}</span>
              &nbsp;
              <span class="stat has-text-danger">{{ s.fail_count }}</span>
            </span>
          </span>
        </div>

        <p class="subtitle" @click="getTransactionsForUser">
          Recent Transactions ({{ transactions.length }})
        </p>
        <div v-show="showTransactions" class="list">
          <span v-for="t in transactions" class="list-item single-line" :class="{ 'bg-pink': t.is_deleted }" :key="t.id"
            @click="selectTransaction(t)">
            <span v-if="t.workflow_type_name === 'Commerce'" class="tag icon is-success">
              <i class="fa fa-store-alt" />
            </span>
            <span v-else class="tag icon is-link">
              <i class="fa fa-shipping-fast" />
            </span>
            <!-- <span v-if="isDriver(t)" class="tag icon is-success">
              <i class="fa fa-shuttle-van" />
            </span>
            <span v-else class="tag icon is-link">
              <i class="fa fa-user" />
            </span> -->
            <span class="tag">{{ longScheduledTime(t) }}</span>
            <span class="tag is-dark" :class="stateClass(t)">{{
              t.state
            }}</span>
            <span class="tag">
              <i class="fa fa-shuttle-van" v-if="!isDriver(t)" />
              <i class="fa fa-headset" v-else />
              &nbsp;
              {{ otherPartyName(t) }}
            </span>
          </span>
          <span class="list-item" style="background-color: #eee">
            <span @click="getMoreTransactions">
              <span class="icon button is-rounded">
                <i class="fa fa-chevron-down" />
              </span>
            </span>
            <span class="icon button is-rounded is-pulled-right" @click="getTransactionsForUser">
              <i class="fa fa-redo" />
            </span>
          </span>
        </div>
        <div v-if="loadingTransactions" class="has-text-grey">
          <p>Loading Transactions</p>
          <p class="has-text-centered">
            <i class="fa fa-atom fa-spin fa-6x" />
          </p>
        </div>

        <div v-if="t" class="transaction-bottom">
          <div class="notification is-white">
            <button class="delete is-large" @click="closeTransaction"></button>
            <p style="font-size: 1.2em">
              {{ t.workflow_type_name }}
              <span v-if="isDriver(t)" style="margin-right: 4px">- DRIVER</span>
              <span class="tag is-dark" :class="stateClass(t)" @click="changeState(t)">{{ t.state }}</span>
            </p>
            <!-- <p style="font-size: 0.9em; margin: 6px 0">
              <span
                class="has-text-grey link"
                v-clipboard:copy="t.id"
                v-clipboard:success="onCopy"
                >{{ t.id }}</span
              >
            </p> -->

            <p :class="{ 'bg-pink': t.is_deleted }" style="margin: 10px 0">
              <span style="color: grey; font-size: 0.9em; font-weight: 500" @click="infoToast('Created / Scheduled')">{{
                longScheduledTime(t) }}</span>
              <!-- <span
                class="is-white has-text-grey link is-pulled-right"
                style="font-size: 0.8em"
                v-clipboard:copy="t.id"
                v-clipboard:success="onCopy"
                >{{ lastFive(t.id) }}</span
              > -->
            </p>

            <div class="field">
              <span class="single-line">
                <span class="tag is-white is-medium w30">
                  <i class="fa fa-user" />
                </span>
                <span class="tag is-grey is-medium">{{ t.customer.name }}&nbsp;({{
                  t.customer.phone_number
                }})</span>
              </span>
            </div>
            <!-- <br /> -->
            <div class="field" v-if="t.driver">
              <span class="single-line">
                <span class="tag is-white is-medium w30">
                  <i class="fa fa-shuttle-van" />
                </span>
                <span class="tag is-grey is-medium">{{ t.driver.name }}&nbsp;({{ t.driver.phone_number }})</span>
              </span>
            </div>

            <!-- <br /> -->
            <div class="field" v-if="pickupName">
              <span class="single-line">
                <span class="tag is-link is-medium">
                  <i class="fa fa-map-marker-alt" />&nbsp;
                  <span>Pickup</span>
                </span>
                <a class="tag is-white is-medium">
                  <a :href="pickupMapURL">{{ pickupName }}</a>
                </a>
              </span>
            </div>

            <div class="field" v-if="dropoffName">
              <span class="single-line">
                <span class="tag is-primary is-medium">
                  <i class="fa fa-map-marker-alt" />&nbsp;
                  <span>Dropoff</span>
                </span>
                <span class="tag is-white is-medium">
                  <a :href="dropoffMapURL">{{ dropoffName }}</a>
                </span>
              </span>
            </div>

            <div class="field">
              <span class="tag is-info is-medium">
                <i class="fa fa-route" />&nbsp;
                <span>Distance</span>
              </span>
              <span class="tag is-white is-medium">{{ distance || "Unknown" }}m</span>
            </div>

            <!-- Based on pickup/dropoff should pre-fill cash and tukpay fields -->
            <div class="columns is-mobile">
              <div class="column">
                <div class="field">
                  <label class="label">Cash</label>
                  <div class="control has-icons-left">
                    <input class="input" v-model="cash" type="number" placeholder="฿30" />
                    <span class="icon is-small is-left">
                      <i class="fab fa-btc"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">TukPay</label>
                  <div class="control has-icons-left">
                    <input class="input" v-model="tukpay" type="number" placeholder="฿30" />
                    <span class="icon is-small is-left">
                      <i class="fab fa-btc"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">&nbsp;</label>
                  <span class="button has-text-danger" @click="updateTransaction">Update</span>
                </div>
              </div>
            </div>

            <div style="height: 8px" />
            <div class="field">
              <!-- <div class="control">
                <button
                  class="button is-warning is-fullwidth"
                  @click="updateTransaction"
                >Update Transaction</button>
              </div>
              <br />-->
              <span class="is-pulled-right">
                <span class="is-white has-text-grey link" style="font-size: 0.8em" v-clipboard:copy="t.id"
                  v-clipboard:success="onCopy">{{ t.id }}
                </span>
                <i v-if="t.workflow_type_name === 'Commerce'" class="fa fa-external-link-alt has-text-grey"
                  style="padding-left: 6px" @click="goto(`commerce_order/${t.id}`)" /></span>
              <div class="buttons" v-if="!replicate">
                <button class="button is-info" v-if="isScheduled" @click="replicate = true">
                  Replicate
                </button>
                <button class="button is-danger is-outlined is-small is-rounded" @click="softDelete">
                  <span v-if="!t.is_deleted">Delete</span>
                  <span v-else>Un-Delete</span>
                </button>
              </div>
            </div>
            <div v-if="replicate">
              <b-field label="Replication Dates" type="is-success">
                <b-datepicker :min-date="new Date()" placeholder="Select one or more dates" v-model="replicateDates"
                  multiple></b-datepicker>
              </b-field>
              <div class="field" v-if="replicateDates">
                <div class="control">
                  <button class="button is-warning is-fullwidth" @click="replicateTransactions">
                    Replicate Transaction
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="field" v-if="roles.length > 0"> -->
      <div v-if="tab === 'roles'" class="tab">
        <div style="margin-bottom: 20px">
          <p class="subtitle">
            Payment Details
            <span v-if="!(bankAccounts.length + qrCodes.length)" class="tag is-dark is-pulled-right">None</span>
          </p>
          <div v-for="r in bankAccounts" :key="r.id" class="bank-transfer">
            <p style="margin-bottom: 6px; font-weight: 550; opacity: 0.7">
              {{ r.role_name }} - {{ r.business.name }}
            </p>
            <p>{{ r.data.bank_account.bank_name }}</p>
            <p @click="copy(r.data.bank_account.account_number)">
              {{ r.data.bank_account.account_number }}
              &nbsp;<i class="fa fa-copy has-text-info" />
            </p>
            <p>
              {{ r.data.bank_account.name_on_account }}
              <span class="is-pulled-right link has-text-danger" @click="deleteBankAccount(r)">Delete</span>
            </p>
          </div>
          <div v-if="!bankAccounts.length" class="notification is-danger">
            <i class="fa fa-university" />&nbsp;No Bank Account
          </div>
          <div v-for="r in qrCodes" :key="'q' + r.id" style="margin-top: 9px">
            <img class="qr-code" :src="r.data.qr_pic_url" v-img-fallback="imgFallback" />
          </div>
          <div v-if="!qrCodes.length" class="notification is-danger">
            <i class="fa fa-qrcode" />&nbsp;No QR Code
          </div>
        </div>

        <p class="subtitle" @click="showRoles = !showRoles">
          Roles ({{ roles.length }})
          <i class="fa fa-minus fa-sm is-pulled-right" />
        </p>
        <div v-if="showRoles" class="list">
          <span v-if="!roles || !roles.length" class="list-item">
            No Roles
          </span>
          <span v-for="r in roles" class="list-item" :style="roleStyle(r)" :key="r.id" @click="moreInfo(r)">
            <span class="icon" v-if="r.role_name === 'Driver'">
              <i class="fa fa-shuttle-van" />
            </span>
            <span class="icon" v-else-if="r.role_name === 'Dispatcher'">
              <i class="fa fa-phone" />
            </span>
            <span class="icon" v-else>
              <i class="fa fa-user" />
            </span>
            <span class="tag has-text-weight-semibold">
              <i class="fa fa-spinner fa-spin has-text-success" style="margin-right: 5px" v-if="r.state === 'working'" />
              {{ r.role_name }}
            </span>
            <span class="tag is-dark">{{ r.business.name }}</span>
          </span>
        </div>
        <div v-else class="notification is-dark" @click="showRoles = true">
          Show Roles
        </div>
      </div>

      <div v-if="tab === 'user'" class="tab">
        <div v-if="user">
          <div class="is-flex">
            <div style="flex-shrink: 1" @click="gotoDriverWallet">
              <img :src="user.profile_pic_url || fallbackProfPic()" />
            </div>
            <div class="user-name-number">
              <p v-if="user.name" class="has-text-black subtitle">
                {{ user.name }}
                <span class="tag is-pulled-right" @click="editName">
                  <i class="fa fa-pencil-alt" />
                </span>
              </p>
              <p v-else class="has-text-danger is-size-6">*Name not set</p>
              <p v-if="user.data.full_name" style="font-size: 0.8em; margin-bottom: 8px; margin-top: -8px">
                {{ user.data.full_name }}
              </p>
              <p>
                <!-- <span
                  class="has-text-link has-text-weight-medium link"
                  @click="callPhoneNumber(user.phone_number)"
                  >{{ user.phone_number }}</span
                > -->
                <span class="has-text-link has-text-weight-medium link" @click="callPhoneNumber(user.phone_number)">{{
                  user.phone_number }}</span>
                <span class="tags has-addons is-pulled-right" @click="editMobile">
                  <span class="tag">Source</span>
                  <b class="tag is-dark">{{ user.source.toUpperCase() }}</b>
                </span>
              </p>
              <p style="position: absolute; bottom: 0">
                <span v-if="!user.is_deleted" class="link has-text-danger" style="font-size: 0.8em; font-weight: 500"
                  @click="softDeleteUser">Delete User<i class="far fa-trash-alt" style="margin-left: 6px" /></span>
                <span v-else class="button is-success is-small is-rounded" @click="softDeleteUser">Undelete User</span>
              </p>
            </div>
          </div>

          <!-- <div v-if="showCallOptions" class="buttons"> -->
          <div class="buttons single-line">
            <span class="button" @click="showMessageUserPanel = true"><i class="far fa-comment" />&nbsp;Message</span>
            <span class="button" @click="callSkype"><i class="fab fa-skype" /></span>
            <span class="button" @click="callWhatsapp"><i class="fab fa-whatsapp" /></span>
            <span class="button" @click="callTelegram(user.phone_number)"><i class="fab fa-telegram" /></span>
          </div>

          <div v-if="user.data.delinquency_notice" class="notification is-danger">
            <span class="row has-text-light">Delinquency Notice</span>
            {{ user.data.delinquency_notice }}
          </div>

          <div v-if="user.data.warning_notice" class="notification is-warning">
            <span class="row">Warning Notice</span>
            {{ user.data.warning_notice }}
          </div>

          <div v-if="user.data.notes" class="notification is-info">
            <span class="row has-text-light">Notes</span>
            {{ user.data.notes }}
          </div>

          <div class="list">
            <span class="list-item">
              <span class="row">Language</span>
              <span v-if="user.language">{{
                $t("language." + user.language)
              }}</span>
              <span v-else>Default</span>
              <span class="tags has-addons is-pulled-right">
                <span class="tag">Notifications</span>
                <b v-if="userHasNotifications" class="tag is-success">ON</b>
                <b v-else class="tag is-danger">OFF</b>
              </span>
            </span>
            <!-- <span
              class="list-item"
              :style="notificationsStyle"
            >Notifications: {{userHasNotifications}}</span>-->
            <span class="list-item">
              <span class="row">Created</span> {{ userCreatedAt }}
              <span class="tag is-pulled-right">{{
                timeAgo(user.created_at)
              }}</span>
            </span>
            <span class="list-item" @click="updatedAtInfo">
              <span class="row">Updated</span> {{ userUpdatedAt }}
              <span class="tag is-pulled-right">{{
                timeAgo(user.updated_at)
              }}</span>
            </span>
            <span class="list-item" @click="copyUserID">
              <span class="row">UserID</span>
              <span class="tag is-info is-pulled-right">{{ user.id }}</span>
            </span>
            <span class="list-item" @click="copyUUID">
              <span class="row">UUID</span>
              <span class="tag is-pulled-right">{{ user.uuid }}</span>
            </span>
            <span class="list-item" @click="showUserData">
              <span class="row">Data</span>
              <span class="tag is-pulled-right">{{ Object.keys(user.data).length }} fields</span>
            </span>
          </div>
          <!-- <div style="margin-top: -15px; margin-bottom: 15px">
            <img :src="user.profile_pic_url || fallbackProfPic()" />
            <div class="is-pulled-right">
              <span
                v-if="!user.is_deleted"
                class="link has-text-danger"
                style="font-size: 0.8em; font-weight: 500"
                @click="softDeleteUser"
                >Delete User<i
                  class="far fa-trash-alt"
                  style="margin-left: 6px"
              /></span>
              <span
                v-else
                class="button is-success is-small is-rounded"
                @click="softDeleteUser"
                >Undelete User</span
              >
            </div>
          </div> -->

          <p class="subtitle">
            <i class="fa fa-map-marker-alt" />&nbsp;Addresses
            <span class="has-text-black is-pulled-right is-size-6">
              <span v-if="addresses" @click="gotoPastAddresses"> {{ addresses.length }} <i class="fa fa-history" />
              </span>
              <span v-else>
                <i class="fa fa-spinner fa-spin" />
              </span>
            </span>
          </p>
          <div v-if="addresses" class="list">
            <div v-for="a in addresses" :key="a.id" class="list-item">
              <p class="is-uppercase" style="margin-bottom: 8px">
                <span class="link" @click="showAddress(a)">{{
                  a.address_type
                }}</span>
                <span class="tags is-pulled-right">
                  <span class="tag is-dark" @click="editAddressCoords(a)">{{ a.lat }}, {{ a.lon }}</span>
                  <span class="tag is-white has-text-link" @click="openGoogleMap(a)">
                    <i class="fa fa-external-link-alt" />
                  </span>
                  <span class="tag is-white">{{
                    prettyDate(a.updated_at)
                  }}</span>
                </span>
              </p>
              <p>
                <span class="row link" @click="editAddress(a, 'name')">Name</span>{{ a.name }}
              </p>
              <p>
                <span class="row link" @click="editAddress(a, 'address')">Address</span>{{ a.address }}
              </p>
              <p>
                <span class="row link" @click="editAddress(a, 'notes')">Notes</span>{{ a.notes }}
              </p>
            </div>
          </div>

          <p class="subtitle">
            <i class="fa fa-mobile-alt" />&nbsp;Devices
            <span class="has-text-black is-pulled-right is-size-6">
              <span v-if="devices"> {{ devices.length }} </span>
              <span v-else>
                <i class="fa fa-spinner fa-spin" />
              </span>
            </span>
          </p>
          <div v-if="devices" class="list">
            <div v-for="d in devices" :key="d.id" class="list-item">
              <p @click="toggleDevice(d)">
                {{ JSON.parse(d.data).os }}
                <span class="is-pulled-right tag">{{
                  prettyDate(d.updated_at)
                }}</span>
              </p>
              <p v-if="showDeviceID === d.id" class="device-json">
                <span>{{ prettyDeviceJSON(d.data) }}</span>
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <article class="media">
            <figure class="media-left">
              <p class="image">
                <b-skeleton square width="120px" height="120px"></b-skeleton>
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p>
                  <b-skeleton height="120px"></b-skeleton>
                </p>
              </div>
            </div>
          </article>
        </div>

        <MessageUserPanel v-if="showMessageUserPanel" :ID="ID" @close="showMessageUserPanel = false" />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import MainBackButton from "@/components/MainBackButton";
import EditJSON from "@/components/EditJSON";
import MessageUserPanel from "@/components/MessageUserPanel";

export default {
  name: "UserInfo",
  components: {
    MainBackButton,
    EditJSON,
    MessageUserPanel,
  },
  data() {
    return {
      showMessageUserPanel: false,
      showCallOptions: false,
      showDeviceID: null,
      showRoles: true,
      editUserData: null,
      tab: "user",
      loadingTransactions: false,
      transactionStats: null,
      topShops: null,
      devices: null, // array of user's devices
      addresses: null,
      users: [],
      drivers: [],
      //   passengers: [],
      //   passengerName: "",
      userName: "",
      ID: "", // userID is taken in main
      user: null, // if a user is selected this is user object
      //   selectedPassenger: null,
      selectedDriver: "",
      workflowType: "",
      workflowID: "",
      businessID: "",
      passengerID: "",
      driverID: "",
      cash: null,
      tukpay: null,
      time: null,
      date: null,
      transactions: [],
      t: null, // selected transaction
      roles: [],
      replicate: false,
      replicateDates: null,
      message: null,
      // showRoles: false,
      showMessage: false,
      showTransactions: true,
      imgFallback: {
        loading: this.$store.state.menuItemPlaceholderPic, //birdProfilePic,
        error: this.$store.state.errorProfilePic,
      },
      specialMessageCommands: [
        ":ping",
        ":systemStats",
        ":goto:profile",
        ":updateRoles",
        ":clearCache",
        ":restart",
      ],
      mobileUpdatedMsg:
        "Thank you 🙏🏼 Your TUK App mobile number has been updated to",
    };
  },
  computed: {
    qrCodes() {
      return this.roles.filter((r) => r.data.qr_pic_url);
    },
    bankAccounts() {
      return this.roles.filter((r) => r.data.bank_account);
    },
    userHasNotifications() {
      if (this.user.notification_token !== "") return true;
      return false;
    },
    notificationsStyle() {
      var color = "pink";
      if (this.user.notification_token !== "") color = "lightgreen";
      return `background-color:${color}`;
    },
    userCreatedAt() {
      return new Date(this.user.created_at).toISOString().split("T")[0]; // returns date like YYYY-MM-DD
    },
    userUpdatedAt() {
      return new Date(this.user.updated_at).toISOString().split("T")[0]; // returns date like YYYY-MM-DD
    },
    userStateStyle() {
      if (!this.user) return null;
      if (!this.user.is_deleted) return null;
      var color = this.myColor("verylightpink");
      return `background-color: ${color}`;
    },
    pickupName() {
      if (!this.t.data.pickup_stop) return false;
      return this.t.data.pickup_stop.name;
    },
    dropoffName() {
      if (!this.t.data.dropoff_stop) return false;
      return this.t.data.dropoff_stop.name;
    },
    pickupMapURL() {
      var lat = this.t.data.pickup_stop.lat;
      var lon = this.t.data.pickup_stop.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    dropoffMapURL() {
      var lat = this.t.data.dropoff_stop.lat;
      var lon = this.t.data.dropoff_stop.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    distance() {
      if (!this.t.data.fare) return 0;
      return Math.round(this.t.data.fare.distance);
    },
    isScheduled() {
      if (!this.t.data.scheduled_time) return false;
      return true;
    },
  },
  mounted() {
    // this.$refs.input.focus();
    EventBus.$on("PASTE_SPECIAL_MESSAGE", (txt) =>
      this.pasteSpecialMessage(txt)
    );
  },
  activated() {
    if (!this.$store.getters.isSuperUser) this.goHome();
    if (this.$route.name === "user-lookup") {
      if (!this.user) this.$refs.input.focus();
    }
    if (this.$route.name === "user-info") {
      var id = this.$route.params.id; // this.console(`LogisticsOrder this.$route ${id}`, this.$route);
      if (id) this.selectUser({ value: id, key: null });
    }
  },
  methods: {
    clearUser() {
      this.userName = "";
      this.ID = "";
      this.t = null;
      this.transactions = [];
      this.roles = [];
      this.users = [];
      this.replicate = false;
      this.replicateDates = null;
      this.message = null;
      this.user = null;
    },
    gotoPastAddresses() {
      this.goto(`past_addresses/${this.ID}`)
    },
    toggleCallOptions() {
      this.showCallOptions = !this.showCallOptions;
      if (this.showCallOptions) {
        this.$copyText(this.user.phone_number);
        this.infoToast("Copied user phone number", "top");
      }
    },
    gotoDriverWallet() {
      this.goto("driver_wallet/" + this.ID);
    },
    clearEditJSON() {
      this.editUserData = null;
    },
    saveEditJSON(data) {
      var loader = this.loadingDots("gold");
      this.$store
        .dispatch("updateUserData", {
          userID: this.ID,
          data: { data: data },
        })
        .then((res) => {
          this.user = res.data;
          this.clearEditJSON();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    openGoogleMap(address) {
      console.log("openGoogleMap", address);
      var url = `http://www.google.com/maps/place/${address.lat},${address.lon}`;
      window.open(url, "_blank");
    },
    editAddressCoords(address) {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map-marker-alt'></i>&nbsp;Edit address coordinates
        </p>
        <p style='margin-bottom:12px'>
        Enter as <code>lat,lon</code>
        </p>
        <p style='color:grey; font-size:0.8em'>
        Current coords: ${address.lat}, ${address.lon}
        </p>
        </div>`,
        input: "text",
        inputPlaceholder: "18.739951,98.9316323",
        confirmButtonText: this.$t("submit"),
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: this.bulmaColor("info"),
        inputValidator: (txt) => {
          if (!txt || txt.length < 6 || txt.indexOf(",") === -1)
            return "Enter latitude,longitude";
        },
      }).then((val) => {
        if (val.value) {
          var nospace = val.value.replace(/ /g, "");
          var latString = nospace.split(",")[0];
          var lonString = nospace.split(",")[1];
          var lat = parseFloat(latString);
          var lon = parseFloat(lonString);
          if (!lat || !lon) {
            var msg = `Incorrect format [ ${val.value} ]<br>Please enter latitude,longitude`;
            return this.errorToast(msg);
          }
          var payload = {
            id: address.id,
            lat: lat,
            lon: lon,
          };
          var loader = this.loadingDots("lightgreen");
          this.$store
            .dispatch("editUserAddress", payload)
            .then((res) => {
              console.log("editAddressCoords", res);
              this.infoToast(`Updated coords: ${lat},${lon}`);
              this.getAddressesForUser();
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    editAddress(address, field) {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map-marker-alt'></i>&nbsp;Edit address ${field}
        </p>
        <p style='color:grey; font-size:0.8em'>
        Current value: ${address[field]}
        </p>
        </div>`,
        input: "textarea",
        inputPlaceholder: field,
        inputValue: address[field],
        confirmButtonText: this.$t("submit"),
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: this.bulmaColor("info"),
        inputValidator: (txt) => {
          if (!txt) return "Enter something";
        },
      }).then((val) => {
        if (val.value) {
          var payload = { id: address.id };
          payload[field] = val.value;
          var loader = this.loadingDots("lightgreen");
          this.$store
            .dispatch("editUserAddress", payload)
            .then((res) => {
              console.log("editUserAddress", res);
              this.infoToast(`Updated address.${field}: ${val.value}`);
              this.getAddressesForUser();
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    deleteBankAccount(r) {
      // given a role, delete associated bank account
      console.log("deleteBankAccount", r);
      r.data.bank_account = null;
      var payload = {
        id: r.id,
        data: r.data,
      };
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => {
          console.log("updateRoleData", res);
          this.successToast("Bank account deleted!");
        })
        .catch((err) => console.error("updateRoleData", err))
        .finally(() => loader.hide());
    },
    showUserData() {
      console.log("show user data", this.user.data);
      this.editUserData = this.user.data;
    },
    toggleDevice(d) {
      if (this.showDeviceID === d.id) this.showDeviceID = null;
      else this.showDeviceID = d.id;
      console.log("toggle device", d);
    },
    prettyDeviceJSON(data) {
      return JSON.stringify(JSON.parse(data), null, 3);
    },
    showAddress(a) {
      // delete or edit address
      // this.infoToast(`${a.lat}, ${a.lon}`);
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        Delete Address: <b>${a.address_type}</b>?</p>
        <p>${a.name}</p>
        <p style='color:grey; margin-bottom:10px'>${a.address}</p>
        <p><code style='font-size:0.7em'>${a.id}</code></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Delete",
        confirmButtonColor: this.bulmaColor("danger"),
      }).then((val) => {
        if (val.value) this.softDeleteAddress(a);
      });
    },
    softDeleteAddress(address) {
      var loader = this.loadingDots("red");
      this.$store
        .dispatch("deleteUserAddress", address.id)
        .then(() => {
          this.errorToast("Deleted: " + address.name);
          this.getAddressesForUser();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    editName() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-signature'></i>&nbsp;Enter Name
        </p>
        <p>Must be at least 4 letters</p>
        </div>`,
        input: "text",
        inputValue: this.user.name,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (!val || val.length < 4) return "Invalid name";
        },
      }).then((val) => {
        if (val.value) {
          var payload = {
            id: this.user.id,
            name: val.value,
          };
          var loader = this.loadingDots();
          this.$store
            .dispatch("patchUser", payload)
            .then((res) => {
              this.user = res.data;
              this.successToast("Updated name");
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    editMobile() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-mobile-alt'></i>&nbsp;Enter New Mobile
        </p>
        <p>Thai mobile formats: +66... or 0...</p>
        </div>`,
        input: "text",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (!val) return "Enter a phone number"
          var numeric = val.replace(/\D/g, ''); // strip non-numeric chars
          if (numeric.length < 8 || numeric.length > 12) return "Invalid phone number";
        },
      }).then((val) => {
        if (!val.value) return;
        var phoneNumber = this.parsePhoneNumber(val.value);
        if (!phoneNumber) {
          this.errorToast("Invalid phone number");
          return;
        }
        this.migrateUserAccount(phoneNumber);
      });
    },
    parsePhoneNumber(str) {
      if (str.length < 8) return null;
      if (str[0] === "0") {
        return "+66" + str.substring(1);
      }
      return str;
    },
    migrateUserAccount(phoneNumber) {
      var data = {
        user_id: this.user.id,
        phone_number: phoneNumber,
      };
      var loader = this.loadingDots();
      this.$store
        .dispatch("migrateUserMobile", data)
        .then(() => this.successToast("Account migrated to new mobile"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    copyUserID() {
      this.$copyText(this.user.id);
      this.successToast("Copied user_id");
    },
    copyUUID() {
      this.$copyText(this.user.uuid);
      this.infoToast("Copied uuid");
    },
    specialMessages() {
      this.$swal({
        title: `<span style='font-size:1.1em; position:absolute; left:-40px;'>🧙‍♂️</span><span style='font-size:0.9em'>Special Commands</span>`,
        html: `<div class="psm" style='text-align:left; padding:5px; background-color:#30475e; color:#f2a365'>
        // commands start with a colon <strong style='color:white'>:</strong><br>
        <p onclick='pasteSpecialMessage(":ping")'>:ping</p>
        <p onclick='pasteSpecialMessage(":systemStats")'>:systemStats</>
        <p onclick='pasteSpecialMessage(":goto:profile")'>:goto:profile</p>
        <p onclick='pasteSpecialMessage(":updateRoles")'>:updateRoles</p>
        <p onclick='pasteSpecialMessage(":clearCache")'>:clearCache</p>
        <p onclick='pasteSpecialMessage(":restart")'>:restart</p>
        <br>
        <i style='font-size:0.9em; color:white'>Recipient's app needs to be open. You will get a confirmation reply on success.</i>
        </div>`,
        background: "#222831",
        showCloseButton: true,
        showConfirmButton: false,
        allowEscapeKey: true,
      });
    },
    pasteSpecialMessage(txt) {
      this.message = txt;
      this.$swal.close();
    },
    pushSpecialMessage(txt) {
      this.message = txt;
      this.sendMessage("push");
      this.successToast("Sending notification...", "top");
    },
    closeTransaction() {
      this.t = null;
      this.replicateDates = null;
      this.replicate = false;
    },
    changeState(t) {
      alert("changeState", t.state);
      // screate new endpoint for this that can change state without updating timestamp
    },
    // isWorker(t) {},
    isDriver(t) {
      return t.handled_by === this.ID;
    },
    // otherPartyName(t) {
    //   if (this.isDriver(t)) return t.customer.name || t.customer.phone_number;
    //   if (!t.driver) return "-"; // if no driver
    //   return t.driver.name || t.driver.phone_number;
    // },
    otherPartyName(t) {
      // if user is the worker...
      if (t.handled_by === this.ID) {
        if (this.isCommerce(t)) return "User is Commerce Agent";
        else return "User is Driver";
      }
      if (!t.driver) return "-"; // if no driver
      return t.driver.name || t.driver.phone_number;
    },
    isCommerce(t) {
      return t.workflow_type_name === "Commerce";
    },
    selectUser(u) {
      this.t = null; // clear any previously selected transaction
      this.ID = u.value;
      this.userName = u.key;
      console.log("selectUser", u);
      this.users = []; // clear list after selection
      this.getTransactionsForUser();
      this.getTransactionStatsForUser();
      this.getRolesForUser();
      this.getUserInfo();
      this.getDevicesForUser();
      this.getAddressesForUser();
      this.topShops = null; // clear this
    },
    getMoreTransactions() {
      var payload = { userID: this.ID, offset: this.transactions.length };
      this.loadingTransactions = true;
      this.$store
        .dispatch("getRelevantTransactionsForUser", payload)
        .then((res) => {
          console.log("getMoreTransactions", res);
          if (res.data) this.transactions = this.transactions.concat(res.data);
          else alert("No more transactions");
        })
        .catch((err) => console.error("getRelevantTransactionsForUser", err))
        .finally(() => (this.loadingTransactions = false));
    },
    getTransactionsForUser() {
      var payload = { userID: this.ID, offset: 0 };
      this.loadingTransactions = true;
      this.$store
        .dispatch("getRelevantTransactionsForUser", payload)
        .then((res) => {
          if (res.data) this.transactions = res.data;
          else this.transactions = [];
        })
        .catch((err) => console.error("getRelevantTransactionsForUser", err))
        .finally(() => (this.loadingTransactions = false));
    },
    getTransactionStatsForUser() {
      this.transactionStats = null;
      this.$store
        .dispatch("getTransactionStatsForUser", this.ID)
        .then((res) => {
          if (res.data) this.transactionStats = res.data;
          else this.transactions = [];
        })
        .catch((err) => this.apiError(err));
      // .finally(() => (this.loadingTransactions = false));
    },
    showTopShops() {
      // get the top shops
      this.$store
        .dispatch("getTransactionTopShopsForUser", this.ID)
        .then((res) => {
          if (res.data) this.topShops = res.data;
          else this.topShops = [];
        })
        .catch((err) => this.apiError(err));
    },
    getRolesForUser() {
      this.$store
        .dispatch("getRolesByUserID", this.ID)
        .then((res) => {
          if (res.data) this.roles = res.data;
          else this.roles = [];
        })
        .catch((err) => console.error("getRolesForUser", err));
    },
    getDevicesForUser() {
      this.$store
        .dispatch("getDevicesByUserID", this.ID)
        .then((res) => (this.devices = res.data))
        .catch((err) => this.apiError(err));
    },
    getAddressesForUser() {
      this.$store
        .dispatch("getAddressesByUserID", this.ID)
        .then((res) => (this.addresses = res.data))
        .catch((err) => this.apiError(err));
    },
    getUserInfo() {
      this.user = null;
      this.$store
        .dispatch("getUserInfo", this.ID)
        .then((res) => {
          console.log("getUserInfo", res);
          this.user = res.data.user;
          if (!this.userName) {
            this.userName = `${this.user.name} (${this.user.phone_number})`;
          }
        })
        .catch((err) => console.error("getUserInfo", err));
    },
    selectTransaction(t) {
      this.t = t;
      if (t.data.fare) {
        this.cash = t.data.fare.cash;
        this.tukpay = t.data.fare.tukpay;
      }
    },
    // pickupName() {
    //   if (!this.t.data.pickup_stop) return false;
    //   return this.t.data.pickup_stop.name;
    // },
    // dropoffName() {
    //   if (!this.t.data.dropoff_stop) return false;
    //   return this.t.data.dropoff_stop.name;
    // },
    updatedAtInfo() { },
    softDelete() {
      // api should toggle is_deleted flag, so if deleted will un-delete too
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteTransaction", this.t.id)
        .then(() => this.closeTransaction())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    selectPassenger(p) {
      this.passengerID = p.value;
      console.log("selectPassenger", p);
      this.passengerName = p.key;
      this.passengers = [];
    },
    selectBusiness(e) {
      var key = e.target.value;
      var b = this.businesses.find((b) => b.key === key);
      this.businessID = b.business_id;
      this.workflowID = b.workflow_id;
      console.log("selected business", key, b);
      // now fetch business-workflow drivers
      this.$store
        .dispatch("autocompleteDriverWorkflows", b.workflow_id)
        .then((res) => {
          if (res.data) this.drivers = res.data;
          else this.drivers = [];
        })
        .catch((err) => console.error("autocompleteDrivers", err));
    },
    selectDriver(e) {
      this.driverID = e.target.value;
      console.log("selected driver", this.driverID, e);
    },
    stateClass(t) {
      if (t.state === "alighted") return "is-success";
      var cancelled = ["cancelled_by_passenger", "no_show"];
      if (cancelled.includes(t.state)) return "is-warning";
      var active = ["initiated", "confirmed", "driver_arrived", "enroute"];
      if (active.includes(t.state)) return "is-info";
    },
    // backgroundStyle(t) {
    //   if (t.is_deleted) return "background-color: pink"; // might never be used
    // },
    roleStyle(r) {
      if (r.is_deleted) return "background-color: pink"; // might never be used
    },
    onCopy(e) {
      this.$swal({
        title: e.text,
        text: "Copied to clipboard!",
        showConfirmButton: false,
        timer: 1000,
      });
    },
    copy(txt) {
      this.$copyText(txt);
      this.infoToast(`Copied ${txt}`, "top");
    },
    lookupUsers(e) {
      var text = e.target.value;
      this.userName = text;
      var search = text;
      if (text[0] === "0") search = text.substring(1);
      console.log("lookupUsers", search);
      if (text.length < 3) {
        this.users = [];
      } else {
        this.$store
          .dispatch("autocompleteUsers", search)
          .then((res) => {
            if (res.data) this.users = res.data;
            else this.users = [];
          })
          .catch((err) => console.error("userAutocomplete", err));
      }
    },
    getFare() {
      if (!this.tukpay) this.tukpay = 0;
      if (!this.cash) this.cash = 0;
      var price = parseInt(this.tukpay) + parseInt(this.cash);
      var discount = parseInt(this.tukpay);
      return {
        version: "v1",
        price: price,
        discount: discount,
        cash: parseInt(this.cash),
        tukpay: parseInt(this.tukpay),
      };
    },
    formCompleted() {
      if (
        // this.driverID === "" ||
        this.passengerID === "" ||
        !this.pickup // || !this.dropoff
      ) {
        this.warningAlert("Please enter passenger and pickup details");
        return false;
      }
      if (this.date && !this.time) {
        this.warningAlert("You must set a time");
        return false;
      }
      return true;
    },
    parseScheduledTime() {
      if (!this.date) {
        return this.time.toISOString(); // time will always be set currently
      }
      // actually could let user not enter and default to NOW, not scheduled
      var dt = this.date;
      dt.setHours(this.time.getHours());
      dt.setMinutes(this.time.getMinutes());
      if (dt < new Date()) {
        alert("Scheduled time cannot be in the past!!");
        return null; // can't be in the past
      }
      return dt.toISOString();
    },
    prettyDate(str) {
      var dt = new Date(str);
      return dt.toLocaleDateString();
    },
    moreInfo(r) {
      var shortID = this.lastFive(r.id);
      var t = new Date(r.updated_at);
      var timeDiff = Math.round((new Date() - t) / (1000 * 60));
      var prettyTime = `${timeDiff} mins ago`;
      var dataJSON = JSON.stringify(r.data, null, 2);
      if (timeDiff > 60) {
        timeDiff = Math.round(timeDiff / 60);
        prettyTime = `${timeDiff} hours ago`;
      }
      this.$swal({
        // title: `<i class='fa fa-user-astronaut fa-2x' style='color:purple' />`,
        html: `<div style="text-align:left">
        <p style='font-size:1.2em; margin-bottom:12px'>Role Info</p>
        Business <strong>${r.business.name}</strong><br>
        Role name <strong>${r.role_name}</strong><br>
        Role ID <strong>${shortID}</strong><br>
        Updated <strong>${prettyTime}</strong><br>
        <p style='background-color:#42a; color:#1e0; font-size:0.9em; padding:3px; border-radius:3px'>
          ${dataJSON}
        </p></div>`,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: `Delete <i class='fa fa-bomb' style='color:black' />`,
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("info"),
        confirmButtonText: `Edit <i class='fa fa-pencil-alt' style='color:black' />`,
        showCloseButton: true,
      }).then((val) => {
        if (val.value) {
          if (r.role_name === "Driver") {
            EventBus.$emit("EDIT_ROLE_MODAL", r);
          } else {
            EventBus.$emit("ROLE_EDIT_JSON_MODAL", r);
          }
        }
        if (val.dismiss === "cancel") this.deleteRole(r);
      });
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    deleteRole(r) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteRole", r.id) // should soft delete
        .then((res) => this.console("deleteRole", res))
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.getRolesForUser(); // update roles
        });
    },
    replicateTransactions() {
      var original = new Date(this.t.data.scheduled_time);
      if (Array.isArray(this.replicateDates)) {
        this.replicateDates.forEach((dt) => {
          var diffDays = Math.ceil((dt - original) / (1000 * 60 * 60 * 24));
          var corrected = this.addDays(original, diffDays);
          var date = corrected.toISOString().split("T")[0];
          // var date = dt.toISOString().split("T")[0]; // yyyy-mm-dd
          this.console(`replicate to date: ${date} (${diffDays})`);
          this.replicateSingle(date);
          // hit new endpoint here one-by-one with original transaction_id and new date
          // endpoint should copy over the transaction details and update the date etc.
        });
      } else {
        var date = this.replicateDates.toISOString().split("T")[0]; // yyyy-mm-dd
        this.console("replicate to single:", date);
        this.replicateSingle(date);
      }
    },
    replicateSingle(date) {
      var loader = this.loadingDots("lightblue");
      this.$store
        .dispatch("replicateTransaction", {
          transactionID: this.t.id,
          date: date,
        })
        .then(() => this.closeTransaction())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    updateTransaction() {
      //   if (this.time) {
      //     if (!this.parseScheduledTime()) return; // means error parsing time, don't continue
      //     obj.type = "scheduled";
      //     obj.scheduled_time = this.parseScheduledTime();
      //   }
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: { data: { fare: this.getFare() } },
        })
        .then(() => this.closeTransaction())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    sendMessage(type) {
      if (!this.message) return;
      // ping/pong check
      // if (this.message === "ping") this.message += `:${this.userID()}`;
      var msg = this.message;
      if (this.message[0] === ":") msg = ":" + this.userID() + this.message;
      // var loader = this.loadingDots("orange");
      this.$store
        .dispatch("sendMessageToUser", {
          user_id: this.ID,
          message: msg, //this.message,
          type: type, // send type: sms or push
        })
        .then(() => this.infoToast("Message Sent", "top"))
        .catch((err) => this.apiError(err));
      // .finally(() => loader.hide());
    },
    callPhone() {
      var mobile = this.userName.match(/\(([^)]+)\)/)[1];
      this.console("callPhone", mobile);
      window.location.href = `tel:${mobile}`;
    },
    callSkype() {
      var url = `Skype:${this.user.phone_number}?call`;
      window.open(url, "_blank");
      // window.location.href = `Skype:${this.user.phone_number}?call`;
    },
    callWhatsapp() {
      var phoneNumber = this.user.phone_number.replace("+", "");
      var msg = "Your TUK App delivery has arrived";
      var url = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${msg}&type=phone_number&app_absent=0`;
      window.open(url, "_blank");
      // window.location.href = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${msg}&type=phone_number&app_absent=0`;
    },
    callTelegram() {
      var url = `https://t.me/${this.user.phone_number}`;
      window.open(url, "_blank");
    },
    softDeleteUser() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-exclamation-triangle' style='color:red'></i>&nbsp;Really delete user?!
        </p>
        <p>Enter Code then click DESTROY</p>
        </div>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Destroy user 💣",
        cancelButtonText: "Oops... Keep user 😬",
        confirmButtonColor: this.bulmaColor("danger"),
        cancelButtonColor: this.bulmaColor("info"),
        input: "number",
        inputPlaceholder: "Passcode",
        inputValidator: (val) => {
          if (val !== "82801460") return "Incorrect code";
        },
      }).then((val) => {
        if (val.value) {
          var loader = this.loadingDots("red");
          this.$store
            .dispatch("deleteUser", this.ID)
            .then((res) => console.log("deleteUser", res))
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
  },
};
</script>

<style scoped>
.user-info {
  text-align: left;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.dark.user-info {
  background-color: #1f1b24;
}

.input {
  border-radius: 0px;
  /* background-color: #ffc800; */
}

.dark .input {
  background-color: #000000;
  border: 1px solid black;
  color: white !important;
}

.dark input::-webkit-input-placeholder {
  color: #666 !important;
}

.header {
  font-size: 1.2em;
  /* font-weight: 400; */
  /* color: rgba(0, 0, 0, 0.5); */
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
  text-align: left;
  padding: 16px;
  padding-left: 56px;
  background: linear-gradient(0deg,
      var(--crypto-primary) 0%,
      var(--crypto-secondary) 100%);
  /* background-image: url("/img/home2/home-dots-pattern.png");
  background-size: contain;
  background-position: center; */
}

.dark .header {
  color: rgba(255, 255, 255, 0.5);
}

.result-header {
  color: rgba(128, 128, 128, 0.9);
  padding: 6px 0px;
  font-weight: 500;
  margin-bottom: 0;
}

.dark .result-header {
  background-color: rgba(255, 255, 0, 0);
}

li a {
  color: #aaa;
}

li a:hover {
  color: #777;
  border-bottom: 2px solid #999;
}

li.is-active a {
  color: #333;
  border-bottom: 2px solid #555;
}

.dark li.is-active a {
  color: gold;
  border-bottom: 2px solid gold;
}

.notification {
  padding: 12px;
  margin-bottom: 10px;
}

.column {
  padding-bottom: 0;
  padding-right: 4px;
}

.list-item {
  padding: 14px 12px;
}

.edit-transaction {
  overflow: auto;
  height: calc(100vh - 60px);
}

.tag {
  padding: 0 6px;
}

.tags {
  margin-bottom: 0;
}

.single-line {
  white-space: nowrap;
  overflow: auto;
}

img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
  background-color: lightgoldenrodyellow;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}

.notification.is-white {
  box-shadow: 0 0 2px grey;
}

.tab {
  padding: 10px;
  padding-bottom: 40px;
}

.subtitle {
  color: grey;
  margin-bottom: 8px;
}

strong {
  margin-left: 4px;
}

.single-line {
  white-space: nowrap;
  overflow: auto;
}

.bank-transfer {
  padding: 6px;
  background-color: #ddd;
  border-radius: 4px;
  box-shadow: 0px 0px 2px grey;
  color: black;
}

.qr-code {
  width: 100vw;
  height: auto;
  border-radius: 4px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.link {
  border-bottom: 1px #ccc dotted;
}

.transaction-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  /* border-radius: 20px; */
}

.bg-pink {
  background-color: pink;
}

.w30 {
  width: 30px;
  text-align: center;
}

.stat {
  display: inline-block;
  width: 50px;
  text-align: center;
  font-weight: 500;
  background-color: #eee;
  border-radius: 3px;
}

.row {
  font-weight: 500;
  color: grey;
  font-size: 0.9em;
  margin-right: 6px;
}

.user-name-number {
  flex: 1;
  margin-left: 4px;
  padding: 4px;
  height: 120px;
  position: relative;
  background-color: white;
  border-radius: 3px;
  border: 1px solid #ddd;
}

.device-json {
  white-space: pre-wrap;
  background-color: darkslategrey;
  color: lightsalmon;
  padding: 0 3px;
  border-radius: 3px;
  margin-top: 8px;
}

.user {
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 100px;
}

.msg-btns {
  display: flex;
  margin-bottom: 16px;
  gap: 6px;
}

.msg-btns .button {
  flex: 1;
}

.buttons {
  margin-bottom: 10px;
}
</style>

<style>
/* global for swal button used in magic messages */
.psm p {
  padding: 6px;
  margin-bottom: 2px;
  border: 1px solid #666;
  border-radius: 6px;
}
</style>